// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, PropsWithChildren, ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingPage } from "../pages/LoadingPage";

interface SignInRedirectPropsInterface {
}

export const SignInRedirect: FunctionComponent<PropsWithChildren<SignInRedirectPropsInterface>> = (
): ReactElement => {

    const lastLocation = sessionStorage.getItem('lastLocation');
    const navigate = useNavigate();

    useEffect(() => {
        if (lastLocation) {
            sessionStorage.removeItem('lastLocation');
            navigate(lastLocation);
        } else {
            sessionStorage.removeItem('lastLocation');
            navigate('/support/cases');
        }
    }, []);

    return (
        <LoadingPage />
    );
}
